
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "./support.scss"
export default function Support({ appLong }) {

  const author = "Marlin Brandin"
  const address = "Charlottenburger Ufer 4, 10029 Berlin, Germany"
  const app = appLong
  const email = "info@mbrandin.com"
  const [lang, setLand] = useState("en")

  return (
    <div className='privacy'>
      <h1>Contact Support {appLong} </h1>

      <h2>Get directly into contact with us</h2>

      <p><a href="mailto:info@mbrandin.com">info@mbrandin.com</a></p>

    


    </div>
  )
}
